(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["faq"] && !window.DesignMode) return;
  try {
    
const faqs = document.querySelectorAll('.faq');
faqs.forEach((faq) => {
  faq.addEventListener('click', (event) => {
    faq.classList.toggle('faq--open')
    console.log(faq);console.log(this);
  });
});

  } catch(e) { console.error(e); }
})();

})();
